import * as React from "react"

export const firstPlaceTrophy = (props) => {
  return (
    <svg
      width={55}
      height={55}
      viewBox="0 0 55 55"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{"Group 11"}</title>
      <defs>
        <path id="prefix__a" d="M15.5 31H31V0H0v31z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle fill="gold" cx={27.5} cy={27.5} r={27.5} />
        <g transform="translate(12 12)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            d="M13.101 3.875h-1.786c.483 4.027 2.399 9.071 4.185 11.04-1.453-3.31-2.388-7.232-2.399-11.04zm-4.223 10.9a35.486 35.486 0 01-1.14-2.304c-3.765-1.965-5.214-5.49-5.766-8.074h3.472c-.075-.58-.131-1.191-.178-1.814H0c.48 5.303 3.627 10.451 8.878 12.191zM21.856 2.582c-.475 5.82-2.522 9.34-4.355 12.49-.745 1.282-1.468 2.522-1.993 3.81-.527-1.29-1.252-2.53-2-3.814C11.672 11.92 9.62 8.402 9.144 2.583h12.712zM15.5 20.2c.745 0 1.488.05 2.223.149C19.3 15.869 24.542 11.314 24.542 0H6.458c0 11.312 5.251 15.868 6.833 20.346A16.767 16.767 0 0115.5 20.2zm7.762-7.728c-.37.824-.756 1.59-1.14 2.303 5.251-1.74 8.398-6.89 8.878-12.192h-5.266a32.958 32.958 0 01-.18 1.815h3.472c-.55 2.585-2 6.108-5.764 8.074zm-3.382 13.25l-.692-.37-.693.37.137-.773-.565-.544.778-.107.344-.707.342.707.78.107-.567.544.136.773zm-3.336-.148l-1.057-.566-1.06.566.213-1.182-.867-.83 1.19-.165.524-1.078.523 1.078 1.189.164-.867.83.212 1.183zm-4.068.148l-.693-.37-.693.37.138-.773-.565-.544.777-.107.343-.707.343.707.779.107-.566.544.137.773zm3.024-4.23c-2.84 0-5.497.769-7.78 2.108l2.934 4.35a10.123 10.123 0 014.846-1.224c1.752 0 3.402.439 4.846 1.224l2.934-4.35a15.32 15.32 0 00-7.78-2.108zm8.232 3.085l-2.926 4.338c.83.579 1.575 1.28 2.206 2.085l.62-3.237h3.493a15.439 15.439 0 00-3.393-3.186zm-16.464 0l2.926 4.338c-.83.579-1.575 1.28-2.206 2.085l-.62-3.237H3.875a15.439 15.439 0 013.393-3.186z"
            fill="#FFF"
            mask="url(#prefix__b)"
          />
        </g>
      </g>
    </svg>
  )
}

export const secondPlaceTrophy = (props) => {
  return (
    <svg
      width={55}
      height={55}
      viewBox="0 0 55 55"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{"Group 8"}</title>
      <defs>
        <path id="prefix__a" d="M15.5 31H31V0H0v31z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle fill="#B9DBE5" cx={27.5} cy={27.5} r={27.5} />
        <g transform="translate(12 12)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            d="M13.101 3.875h-1.786c.483 4.027 2.399 9.071 4.185 11.04-1.453-3.31-2.388-7.232-2.399-11.04zm-4.223 10.9a35.486 35.486 0 01-1.14-2.304c-3.765-1.965-5.214-5.49-5.766-8.074h3.472c-.075-.58-.131-1.191-.178-1.814H0c.48 5.303 3.627 10.451 8.878 12.191zM21.856 2.582c-.475 5.82-2.522 9.34-4.355 12.49-.745 1.282-1.468 2.522-1.993 3.81-.527-1.29-1.252-2.53-2-3.814C11.672 11.92 9.62 8.402 9.144 2.583h12.712zM15.5 20.2c.745 0 1.488.05 2.223.149C19.3 15.869 24.542 11.314 24.542 0H6.458c0 11.312 5.251 15.868 6.833 20.346A16.767 16.767 0 0115.5 20.2zm7.762-7.728c-.37.824-.756 1.59-1.14 2.303 5.251-1.74 8.398-6.89 8.878-12.192h-5.266a32.958 32.958 0 01-.18 1.815h3.472c-.55 2.585-2 6.108-5.764 8.074zm-3.382 13.25l-.692-.37-.693.37.137-.773-.565-.544.778-.107.344-.707.342.707.78.107-.567.544.136.773zm-3.336-.148l-1.057-.566-1.06.566.213-1.182-.867-.83 1.19-.165.524-1.078.523 1.078 1.189.164-.867.83.212 1.183zm-4.068.148l-.693-.37-.693.37.138-.773-.565-.544.777-.107.343-.707.343.707.779.107-.566.544.137.773zm3.024-4.23c-2.84 0-5.497.769-7.78 2.108l2.934 4.35a10.123 10.123 0 014.846-1.224c1.752 0 3.402.439 4.846 1.224l2.934-4.35a15.32 15.32 0 00-7.78-2.108zm8.232 3.085l-2.926 4.338c.83.579 1.575 1.28 2.206 2.085l.62-3.237h3.493a15.439 15.439 0 00-3.393-3.186zm-16.464 0l2.926 4.338c-.83.579-1.575 1.28-2.206 2.085l-.62-3.237H3.875a15.439 15.439 0 013.393-3.186z"
            fill="#FFF"
            mask="url(#prefix__b)"
          />
        </g>
      </g>
    </svg>
  )
}

export const thirdPlaceTrophy = (props) => {
  return (
    <svg
      width={55}
      height={55}
      viewBox="0 0 55 55"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{"Group 8"}</title>
      <defs>
        <path id="prefix__a" d="M15.5 31H31V0H0v31z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle fill="peru" cx={27.5} cy={27.5} r={27.5} />
        <g transform="translate(12 12)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            d="M13.101 3.875h-1.786c.483 4.027 2.399 9.071 4.185 11.04-1.453-3.31-2.388-7.232-2.399-11.04zm-4.223 10.9a35.486 35.486 0 01-1.14-2.304c-3.765-1.965-5.214-5.49-5.766-8.074h3.472c-.075-.58-.131-1.191-.178-1.814H0c.48 5.303 3.627 10.451 8.878 12.191zM21.856 2.582c-.475 5.82-2.522 9.34-4.355 12.49-.745 1.282-1.468 2.522-1.993 3.81-.527-1.29-1.252-2.53-2-3.814C11.672 11.92 9.62 8.402 9.144 2.583h12.712zM15.5 20.2c.745 0 1.488.05 2.223.149C19.3 15.869 24.542 11.314 24.542 0H6.458c0 11.312 5.251 15.868 6.833 20.346A16.767 16.767 0 0115.5 20.2zm7.762-7.728c-.37.824-.756 1.59-1.14 2.303 5.251-1.74 8.398-6.89 8.878-12.192h-5.266a32.958 32.958 0 01-.18 1.815h3.472c-.55 2.585-2 6.108-5.764 8.074zm-3.382 13.25l-.692-.37-.693.37.137-.773-.565-.544.778-.107.344-.707.342.707.78.107-.567.544.136.773zm-3.336-.148l-1.057-.566-1.06.566.213-1.182-.867-.83 1.19-.165.524-1.078.523 1.078 1.189.164-.867.83.212 1.183zm-4.068.148l-.693-.37-.693.37.138-.773-.565-.544.777-.107.343-.707.343.707.779.107-.566.544.137.773zm3.024-4.23c-2.84 0-5.497.769-7.78 2.108l2.934 4.35a10.123 10.123 0 014.846-1.224c1.752 0 3.402.439 4.846 1.224l2.934-4.35a15.32 15.32 0 00-7.78-2.108zm8.232 3.085l-2.926 4.338c.83.579 1.575 1.28 2.206 2.085l.62-3.237h3.493a15.439 15.439 0 00-3.393-3.186zm-16.464 0l2.926 4.338c-.83.579-1.575 1.28-2.206 2.085l-.62-3.237H3.875a15.439 15.439 0 013.393-3.186z"
            fill="#FFF"
            mask="url(#prefix__b)"
          />
        </g>
      </g>
    </svg>
  )
}

// export default firstPlaceTrophy
// export default secondPlaceTrophy
// export default thirdPlaceTrophy


// WEBPACK FOOTER //
// ./src/features/contests/util/getTrophyImage.js